const PUBLIC_URL = process.env.PUBLIC_URL;

export const HOME_URL = `${PUBLIC_URL}/`;
export const TERMS_AND_CONDITIONS_URL = `${PUBLIC_URL}/terms-and-conditions`;
export const PRIVACY_POLICY_URL = `${PUBLIC_URL}/privacy-policy`;
export const USER_CONTENT_PERMISSION_URL = `${PUBLIC_URL}/user-content-permission`;
export const THANK_YOU_URL = `${PUBLIC_URL}/thank-you/:type`;
